import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Admin } from "@/pages/Admin";
import { Breakdown } from "@/pages/Breakdown";
import { Login } from "@/pages/Login";
import { Logs } from "@/pages/Logs";
import { Overview } from "@/pages/Overview";
import { Timeseries } from "@/pages/Timeseries";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Telemetry is append-only; a few seconds of staleness is fine and keeps
      // the aggregation queries off the cluster on every tab switch.
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function Shell() {
  const { signedIn } = useAuth();
  if (!signedIn) return <Login />;

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="timeseries" element={<Timeseries />} />
        <Route path="breakdown" element={<Breakdown />} />
        <Route path="logs" element={<Logs />} />
        <Route path="admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
